type TickersApiRequest = {
    ids: string[];
};

export async function fetchTickersFromApi({ ids }: TickersApiRequest) {
    const securitiesResponse = await fetch(
        `/lineup-next/api/tickers?ids=${ids.join(",")}`
    );

    if (!securitiesResponse.ok) {
        throw new Error(
            `Error when fetching from api/securities: ${securitiesResponse.text()}`
        );
    }

    return securitiesResponse.json();
}
